import React from 'react';
import ClassAssembly  from 'views/ClassAssembly1D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;